import Entity from './entity';
export default class Refund extends Entity<string> {
  orderId: string;
  paymentRule: number;
  total: number;
}
